export const Styles = {
  openButtonImageCSS: 'height: 30px; width: 30px; margin-bottom:-10px;',
  closeButtonImageCSS: 'height: 30px; width: 30px; margin-top: 5px;',
  openButtonCSS: 'position: fixed; outline: none; border: 2px solid white; border-radius: 35px; margin: 20px; margin-top: 10px; cursor: pointer; bottom: 0; right: 0; background-color: #147582; box-shadow: 0 2px 10px 1px #b5b5b5; height: 60px; display: flex; align-items: center; justify-content: center; padding-left: 10px; z-Index: 99999; padding-top:2px; padding-bottom:0px',
  closeButtonCSS: 'position: fixed; outline: none; border: 2px solid white; border-radius: 35px; margin: 20px; margin-top: 10px; cursor: pointer; bottom: 0; right: 0; background-color: #147582; box-shadow: 0 2px 10px 1px #b5b5b5; height: 60px; width: 60px; display: flex; justify-content: center; align-items: center; z-Index: 99999;',
  mobileOpenButtonCSS: 'position: fixed; outline: none; border: 2px solid white; border-radius: 35px; margin: 20px; margin-top: 10px; cursor: pointer; bottom: 0; right: 0; background-color: #147582; box-shadow: 0 2px 10px 1px #b5b5b5; height: 60px; width: 60px; z-Index: 99999; display: flex; align-items: center; justify-content: center;',
  mobileCloseButtonCSS: 'position: fixed; outline: none; border: 0; border-radius: 35px; height: 30px; width: 30px; right: 20px; display: flex; align-items: center; justify-content: center; margin-top: 10px; top: 0px; background-color: #147582; z-Index: 99999;',
  launcherOpenTextCSS: 'color: white; font-size: 14px; margin-left: 10px; margin-right: 10px; font-family: Averta-ExtraBold;',
};

export const Icons = {
  launcherButton: 'https://www.sonnet.ca/asset/icons/chatbot/five9-chat-active.svg?language_id=1',
  closeButton: 'https://www.sonnet.ca/asset/icons/chatbot/five9-chat-minimize-button.svg?language_id=1',
  minimizeButton: 'https://www.sonnet.ca/asset/icons/chatbot/five9-chat-minimize-button.svg?language_id=1',
  chatStartImage: 'https://www.sonnet.ca/asset/gifs/ChatBotAnimation.gif',
};

export const Scripts = {
  jQuery: 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js',
  five9Plugin: 'https://psapps006.scl.five9.com/ps-live-chat/Five9ChatPlugin.js',
};

export const CSSDomain = 'https://www.sonnet.ca/five9/';

export const translationKeys = {
  subtitle: 'chatbot.message.us',
  senderPlaceHolder: 'chatbot.placeholder',
  launcherOpenLabel: 'chatbot.open.label',
  launcherOpenText: 'chatbot.open.text',
  launcherCloseLabel: 'chatbot.close.label',
  chatStartMessage: 'chatbot.chat.start.message',
  chatEndMessage: 'chatbot.chat.end.message',
  endButtonText: 'chatbot.end.button.text',
};
